import { useQuery } from "react-query";
import axios from "axios";
import moment from "moment";
import __ from "lodash";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const augmentData = (data) => {
  const augmentedData = data.map((record) => {
    if (!__.has(record, "flightNo") && __.has(record, "viaRouting") && !__.isEmpty(record.viaRouting)) {
      const matches = record.viaRouting.departureFlight?.match(/^([A-Z0-9]{1,2}[A-Z]{0,1})-([0-9]{3,4}[A-Z]{0,1}) ([0-9]{2} [A-Za-z]{3} [0-9]{2}:[0-9]{2}) ([A-Z]{3})-([A-Z]{3}).*/);
      if (matches && Array.isArray(matches)) {
        record["airlineCode"] = matches.length > 1 ? matches[1] : "";
        record["flightNo"] = matches.length > 2 ? matches[2] : "";
        record["scheduledDepartureTimeUTC"] = matches.length > 3 ? moment.utc(matches[3], "DD MMM HH:mm").toISOString(): "";
        record["originAirportCode"] = matches.length > 4 ? matches[4] : "";
        record["destinationAirportCode"] = matches.length > 5 ? matches[5] : "";
      }
    }

    if (!record.spotChargeableWeight || Number(record.spotChargeableWeight) === 0)
      record.spotChargeableWeight = record.expectedChargeableWeight;
    return {
      ...record,
      tripDateDDMMM: record.tripDate ? moment(record.tripDate).format("DD MMM") : record.requestedDate ? moment(record.requestedDate).format("DD MMM") : "",
      expectedWeightKgRounded: Number(record.expectedWeightKg)?.round(1).toLocaleString(),
      expectedChargeableWeightRounded: Number(record.expectedChargeableWeight)?.round(1).toLocaleString(),
      spotChargeableWeightRounded: Number(record.spotChargeableWeight)?.round(1).toLocaleString(),
      expectedVolumeRounded: Number(record.expectedVolume)?.round(1).toLocaleString(),
      rateRounded: isNaN(Number(record.rate)) ? 0 : Number(record.rate)?.round(4).toLocaleString(),
      customerTargetRateRounded: Number(record.customerTargetRate)?.round(4).toFixed(2).toLocaleString(),
      offeredSpotRateRounded: Number(record.offeredSpotRate)?.round(4).toFixed(2).toLocaleString(),
      eurAmountRounded: Number(record.eurAmount)?.round(2).toLocaleString(),
      usdAmountRounded: Number(record.usdAmount)?.round(2).toLocaleString(),
      gbpAmountRounded: Number(record.gbpAmount)?.round(2).toLocaleString(),
      bookedUsdAmountRounded: Number(record.bookedUsdAmount)?.round(2).toLocaleString(),
      mainDeck: record.deckRequired === "LOWER",
      awbNo: `${record.awbPrefix}-${record.awbSerial.toString().padStart(8, "0")}`,
      tripNumber: record.tripNumber ?? `${record.tripPrefix}${record.tripNo}`,
    }
  });
  return augmentedData;
}

const getData = async (tableRef, queryClient, key, extraKeys, useCache, callback) => {
  if (tableRef && tableRef.current && tableRef.current.state && tableRef.current.state.lastEditingRow){
    return queryClient.getQueryData(key);
  }
  if (useCache) {
    const cachedData = queryClient.getQueryData([...key, '_cached']);
    if (cachedData) {
      if (callback) {callback(cachedData, extraKeys)}
      return cachedData
    };
    const realData = queryClient.getQueryData(key);
    if (realData) {
      if (callback) {callback(realData, extraKeys)}
      return realData;
    }
  }
  let extendedPath = "";
  if (extraKeys) {
    extendedPath = extraKeys.join("/");
  }
  const { data } = await axios.get(
    `${apiSitePrefix}/bookings/list/${extendedPath}`
  );
  if (callback) {callback(augmentData(data), extraKeys)}
  return augmentData(data);
};

const buildKey = (props) => {
  let key = ['Bookings'];
  if (props.extraKeys) {
    key = [
      ...key,
      ...props.extraKeys
    ]
  }
  const queryKey = [...key];
  if (props.useCache) {
    queryKey.push('_cached');
  }

  return {key, queryKey};
}

export default function useBookings(props) {
  const options = {
    ...props.options
  }

  const {key, queryKey} = buildKey(props);

  return useQuery(
    queryKey,
    () => getData(props.tableRef, props.queryClient, key, props.extraKeys, props.useCache, props.callback),
    options
  );
}
export {buildKey}
